import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client/react";
import { Provider } from "react-redux";
import store from "./store";
import { apolloClient } from "./graphql";
import PageNavigation from "./components/PageNavigation";
import { useSnackbar } from "notistack";
import * as serviceWorker from "./serviceWorkerRegistration";
import { Button } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import "./index.scss";

const App = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState({});

  useEffect(() => {
    let tempLoc = sessionStorage.getItem("selectedLocation");
    if (!tempLoc || tempLoc === undefined || tempLoc === null) {
      sessionStorage.setItem(
        "selectedLocation",
        JSON.stringify({ locationNo: "NA", locationName: "NA" })
      );
    }
    const onServiceWorkerUpdate = (registration) => {
      setWaitingWorker(registration?.waiting);
      setNewVersionAvailable(true);
    };

    const updateServiceWorker = () => {
      waitingWorker?.postMessage({ type: "SKIP_WAITING" });
      setNewVersionAvailable(false);
      globalThis.location.reload();
    };

    const refreshAction = (key) => {
      //render the snackbar button
      return (
        <Button
          className="snackbar-button"
          size="small"
          variant="outlined"
          onClick={updateServiceWorker}
        >
          {"Refresh"}
        </Button>
      );
    };

    serviceWorker.register({ onUpdate: onServiceWorkerUpdate });

    if (newVersionAvailable)
      //show snackbar with refresh button
      enqueueSnackbar("A new version was released !", {
        persist: true,
        variant: "info",
        action: refreshAction,
      });
  });



  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <StyledEngineProvider injectFirst>
          <BrowserRouter>
            <div className="App">
              <PageNavigation />
            </div>
          </BrowserRouter>
        </StyledEngineProvider>
      </ApolloProvider>
    </Provider>
  );
};

export default App;
